<div class="d-flex flex-column flex-root " id="kt_login_wrapper">
    <!--begin::Login-->
    <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">

        <div class="parent login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden  mx-auto    " >

            <div class="d-flex justify-content-lg-end justify-content-end align-items-end w-100 p-7" >
                <div class="flex-grow-2" >
                    <img src="./assets/media/project-logos/Logo.png" class="max-h-90px  cursor-pointer" style="margin-left: 20px;max-height: 60px !important;" alt=""  (click)="goToDashboard()"/>
                </div>
                <div class="align-self-center d-flex">

                    <i class="fas fa-bars cursor-pointer listing-margin-r-sm " style="color: darkgray;font-size: 2.5rem; display: flex;
align-self: center; margin-right: 20px"  [matMenuTriggerFor]="menu" ></i>

                    <a [routerLink]="" (click)="endSession()"  class=" highlight -primary ml-10 font-weight-bolder font-size-h5 remove-icon">Logout</a>
                </div>
            </div>




            <mat-menu #menu="matMenu" style="padding: 20px !important;border-radius: 20px">
                <a mat-menu-item routerLink="/" class=" font-weight-bolder font-size-h5 ">My Will</a>
                <a  mat-menu-item routerLink="/finish" routerLinkActive="active" class=" font-weight-bolder font-size-h5" >My Plan</a>
                <a mat-menu-item routerLink="/share" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Invite</a>
                <a mat-menu-item routerLink="/download" routerLinkActive="active"class=" font-weight-bolder font-size-h5" style="color: #ef8c43">Download</a>
<!--                <a mat-menu-item routerLink="/review" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Review  Will</a>-->
                <a  [routerLink]="" (click)="endSession()"  mat-menu-item class=" font-weight-bolder font-size-h5 sm-remove-icon">Logout</a>
            </mat-menu>









            <!--end::Content-->



<div style="background: #F9F9F9; width: 100%">
    <div class="pb-13 pt-lg-0 pt-5">
        <p class="font-weight-bolder text-dark text-align-center font-heading mt-15" style="font-size: 2.4rem !important;">
            Congratulations! Your Will is now complete!</p>

        <div *ngIf="plan==0">



        <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F;margin-bottom: 0px !important">

            You’ve subscribed to our <b>Bronze </b>plan, which allows you to come back any time </p>

        <p class="text-align-center " style="font-size: 1.6rem !important; color: #8F8F8F;margin-bottom: 0px !important;">
            to download your Will. If you need to make edits, consider upgrading to our silver </p>

            <p class="text-align-center " style="font-size: 1.6rem !important; color: #8F8F8F">
                plan which also includes review by our specialist legal team! </p>

        </div>

        <div *ngIf="plan==1">

        <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F">
            You’ve subscribed to our <b>Silver</b> plan, so we’ve sent your Will to be reviewed by</p>

            <p class="text-align-center " style="font-size: 1.6rem !important; color: #8F8F8F">
                our specialist legal team, who will be in touch as soon as they’ve validated it.</p>

        </div>


        <div *ngIf="plan==2">

        <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F">
            You’ve subscribed to our <b>Gold</b> plan, so our specialist legal team will be in touch</p>

            <p class="text-align-center " style="font-size: 1.6rem !important; color: #8F8F8F">
                shortly to collect your specific requirements and generate your Gold Will soon. </p>

        </div>




    </div>

    <div class="d-flex align-content-center justify-content-center">

        <!-- <a type="button" href="{{download_link}}" target="_blank" class=" highlight -primary ml-10 font-weight-bolder font-size-h5">Download your will</a> -->
        <a  href="{{download_link}}" class=" highlight -primary ml-10 font-weight-bolder font-size-h5 " style="padding-left: 30px;padding-right: 30px; margin-bottom: 60px">Download your Will</a>

    </div>

    <div class="d-flex align-content-center justify-content-center">
        <img style="width: 100%;" src="assets/media/bg/Group%20277.png" alt="">
    </div>


<!--    <div  class="d-flex justify-content-center" style="padding-bottom: 60px">-->
<!--        <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6 input-field input-share" style="width: 30%;background-color: white;-->
<!--border-color: #EF8C43 !important;-->
<!--color: #3F4254;" type="text" name="firstName" placeholder="Email" autocomplete="on" value="http://wiselife.com.au/freewill" readonly  (click)="openMoreCharities(moreCharities)" />-->
<!--    </div>-->

    <div class="pb-13 pt-lg-0 pt-5">


        <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F">
            Enjoyed making your Will? Invite friends and Family
        </p>

<!--        <a type="button" href="{{download_link}}" target="_blank" class=" highlight -primary ml-10 font-weight-bolder font-size-h5">Download your will</a>-->
        <!-- <a type="button" [attr.href]="getDownloadLink()" target="_blank" class=" highlight -primary ml-10 font-weight-bolder font-size-h5 " style="padding-left: 30px;padding-right: 30px; margin-bottom: 60px">Download your will</a> -->

        <div class=" d-flex justify-content-center align-content-center">
        <div class="d-flex justify-content-center mt-15 back" [ngStyle]="{'background-image': srcimage || ''}" style="width: 90%; height: 300px; border-top-right-radius: 60px;border-bottom-right-radius: 60px; border-bottom-left-radius: 60px">


            <div class="row align-self-center "  style="width: 80%">

                <div class="col-12 col-md-7 col-lg-7 d-flex align-content-center center-content-btn">
                    <p class="font-weight-bolder text-dark text-align-center font-heading align-self-center" style="font-size: 2.0rem !important;">
                        Can we help anyone else ?</p>

                </div>
                <div class="col-12 col-md-4 col-lg-4 d-flex align-content-center center-content-btn">

<!--                    <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6 input-field input-invite" type="text" name="firstName" placeholder="Email" autocomplete="on"  />-->
<!--                    <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6 input-field input-share remove-icon" style="background-color: white;-->
<!--border-color: #EF8C43 !important;-->
<!--color: #3F4254;" type="text" name="firstName" placeholder="Email" autocomplete="on" value="http://wiselife.com.au/freewill" readonly  />-->




                    <a  routerLink="/share" class=" highlight -primary ml-10 font-weight-bolder font-size-h5 align-self-center" style="padding-left: 30px;padding-right: 30px; ;background: #17b551;padding-top: 20px;padding-bottom: 20px;width: 70%; display: block;text-align: center">Invite</a>

                <!-- <div class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6 input-field input-invite half-box">
                    http://wiselife.com.au/freewill
                    <div class="title">
                    Share
                    </div>
                </div> -->

                </div>

            </div>


        </div>
        </div>
    </div>

</div>
            <!--end::Login-->
        </div>


    <div class=" d-flex justify-content-center align-content-center" style="background: white; padding-bottom: 60px" >

    </div>

</div>
</div>

<ng-template #moreCharities let-c="close" let-d="dismiss" class="center-modal rounded-0" >

    <div class="rounded" style="border-radius: 50px">
        <div class="custom-container  rounded-0" >
            <div class="modal-header " style="border: none; background: white; font-size: 1.875em; align-items: center; justify-content: center;border-top-right-radius: 40px;border-top-left-radius: 40px;">

                <span  (click)="d('Cross click')"  class="close-button topright" style="color:#39B54A;border-top-right-radius: 40px;margin-top: 10px;margin-right: 10px;font-size: 2.5rem">&times;</span>
                <!--        <button type="button" class="close " style="color: #00aff0;border-top-right-radius: 40px" aria-label="Close" (click)="d('Cross click')">-->
                <!--            <span aria-hidden="true">&times;</span>-->
                <!--        </button>-->

                <div class="d-flex flex-column justify-content-center">
                    <strong class="modal-title d-flex justify-content-center" style="color: black; font-size: inherit; margin-top: 40px">Share the love</strong>
                    <div class="pb-13 pt-lg-0 pt-5 d-flex justify-content-center" style="width: 100%">

                        <p class="text-align-center font-heading mt-5 d-flex justify-content-center" style="font-size: 0.9rem !important; color: #8F8F8F; width: 90%">
                            Make life a little easier for your family and friends by introducing them to the WiserNow Will creator – why not, its FREE!</p>



                    </div>
                </div>

            </div>
            <div class="modal-body" style="background: white; padding-top: 0px;padding-bottom: 40px;border-bottom-left-radius: 40px;border-bottom-right-radius: 40px;padding-left: 38px;padding-right: 38px">
                <div style=" display: flex !important; flex-direction: column !important;">
                    <div class="search__container">

                        <mat-form-field class=" h-auto  rounded-lg font-size-h6  "  appearance="fill" style="width: 100%; padding-bottom: 20px">

                            <mat-chip-list #chipList aria-label="Fruit selection">
                                <mat-chip *ngFor="let fruit of fruits" (removed)="remove(fruit)">
                                    {{fruit.name | titlecase}}
                                </mat-chip>
                                <input
                                    #chipsInput
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur"
                                    (matChipInputTokenEnd)="add($event)">
                            </mat-chip-list>
                        </mat-form-field>


                        <!--                            <input class=style="color: black" id="typeahead-basic" #searchinput type="text" >-->
                    </div>


                    <div class="d-flex align-content-center justify-content-center" style="margin-top: 10px">

                        <!-- <a routerLink="/thanks"  (click)="closeModal()" class=" highlight -primary font-weight-bolder font-size-h5  share" style="">Share</a> -->
                        <!-- <a  (click)="invite()" routerlink="javascript:void(0);" class="highlight-primary font-weight-bolder font-size-h5 share">Share</a> -->
                        <button (click)="invite()" style="    background: #EF8C43;
                        color: white;
                        padding-left: 20px;
                        padding-right: 20px;
                        padding: 18px !important;
                        padding-left: 42px !important;
                        padding-right: 40px !important;
                        margin-bottom: 10px;
                        background: #39B54A !important;
                        border-radius: 50px;
                        font-size: 1.25rem !important;
                        font-weight: 600 !important;
                        outline: 0 !important;
                        transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
                        text-decoration: none;
                        border: 0;" class="share-btn highlight -primary font-weight-bolder font-size-h5  share">Share</button>

                    </div>


                    <!-- <input id="typeahead-basic" type="text" class="form-control" [(ngModel)]="model" [ngbTypeahead]="search" /> -->
                    <!-- <input type="text" id="name" class="swal2-input" style="color: black;background: white ; border-radius:20px " placeholder="Full Name">
                    <input type="text" id="dob" class="swal2-input" onfocus="(this.type='date')" onblur="if(!this.value)this.type='text'" style="color: black;background: white ; border-radius:20px " placeholder="Date of Birth"> -->
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
      <button type="button" class="btn btn-primary">Save changes</button>
    </div> -->
</ng-template>







<!--<i class="fa fa-check-circle" aria-hidden="true"></i>-->
